
import Vue from 'vue'
import FlexContainer from '~/components/atoms/FlexContainer.vue'

export default Vue.extend({
  components: {
    FlexContainer,
  },
})
